import {
  getCookieWckAuthData,
  getCookieWckDisplayFrontLocation,
  getCookieWckStyleClipNo,
} from '@wconcept/wconcept-common/utils/cookie';
import {
  getAge,
  getAgeGroup,
  getGender,
} from '@wconcept/wconcept-common/utils/commonUtils';
import { getIsMobile } from '@wconcept/wconcept-common/utils/deviceUtil';
import { base64Encrypt } from '@utils/cryptUtils';
import type { IRequestOptions } from './types';

const isSsr = (): boolean => typeof window === 'undefined';

const getMobileDomain = async () => {
  const mDomainValue = await getCookieWckDisplayFrontLocation();

  return mDomainValue?.match(/^(?:https?:\/\/)?([^.]+)/i)?.[1];
};

const setDisplayHeaders = (
  tempOptions: IRequestOptions,
  headers: IRequestOptions['headers']
): void => {
  Object.assign(tempOptions, { headers });
};

export async function applyDisplayHeaders({
  tempOptions,
  options,
  baseUrl,
}: {
  tempOptions: IRequestOptions;
  options: IRequestOptions;
  baseUrl?: string;
}) {
  const displayApi = baseUrl === process.env.NEXT_PUBLIC_DISPLAY_API_BASE_URL;
  const envType = process.env.NEXT_PUBLIC_MODE;
  const dDomain = process.env.NEXT_PUBLIC_WCONCEPT_DISPLAY_WEB_DOMAIN;

  if (isSsr()) {
    if (!options.ssg) {
      const auth = await getCookieWckAuthData();
      const myStyleClipNo = await getCookieWckStyleClipNo();
      const mDomain = await getMobileDomain();
      const { headers } = await import('next/headers');
      const headerList = await headers();
      const ip = headerList.get('X-Forwarded-For') as string;
      const userAgent = headerList.get('user-agent') as string;
      const isMobile = getIsMobile(userAgent);
      const age = getAge(auth?.birth);
      const ageGroup = age === 0 ? '' : getAgeGroup(age);

      setDisplayHeaders(tempOptions, {
        ...options.headers,
        ...(displayApi
          ? { CUST_NO: auth?.userNo }
          : { custNo: base64Encrypt(auth?.userNo) }),
        custId: base64Encrypt(auth.userId),
        profileSeqNo: myStyleClipNo ? base64Encrypt(myStyleClipNo) : '',
        'User-Agent': userAgent,
        'X-Forwarded-For': ip,
        birthDate: auth?.birth ? base64Encrypt(auth?.birth) : '',
        deviceType: isMobile ? 'MOBILE' : 'PC',
        memberGrade: auth?.grade || '',
        genderType: getGender(auth?.gender || '').toUpperCase(),
        ageGroup: ageGroup || '',
        'X-Mdomain': mDomain || '',
        'X-Ddomain': dDomain || '',
      });
    }
  } else {
    const auth = await getCookieWckAuthData();
    const myStyleClipNo = await getCookieWckStyleClipNo();
    const mDomain = await getMobileDomain();
    const age = getAge(auth?.birth);
    const ageGroup = age === 0 ? '' : getAgeGroup(age);
    const { userAgent } = navigator;
    const isMobile = getIsMobile(userAgent);

    setDisplayHeaders(tempOptions, {
      ...options.headers,
      ...(displayApi
        ? { CUST_NO: auth?.userNo }
        : { custNo: base64Encrypt(auth?.userNo) }),
      custId: base64Encrypt(auth?.userId),
      profileSeqNo: myStyleClipNo ? base64Encrypt(myStyleClipNo) : '',
      birthDate: auth?.birth ? base64Encrypt(auth?.birth) : '',
      deviceType: isMobile ? 'MOBILE' : 'PC',
      memberGrade: auth?.grade || '',
      genderType: getGender(auth?.gender || '').toUpperCase(),
      ageGroup: ageGroup || '',
      'X-Mdomain': mDomain || '',
      'X-Ddomain': dDomain || '',
    });
  }

  if (!options.ssg) {
    const auth = await getCookieWckAuthData();
    const headers = tempOptions.headers as Record<string, string>;

    if (envType === 'prod') {
      delete headers['X-Mdomain'];
      delete headers['X-Ddomain'];
    }

    if (auth?.userNo === '0') {
      delete headers.CUST_NO;
      delete headers.custNo;
      delete headers.custId;
    }
  }
}
